import React from 'react';
import CheckIcon from '@wix/da-ds/pkg/Icons/24x24/Check';
import FragmentsIcon from '@wix/da-ds/pkg/Icons/Fragments';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import s from './BenefitField.scss';

interface Props {
  label: string;
  sublabel: string;
  labelType?: 'text' | 'checkmark' | 'fragments';
}

const BenefitField: React.FC<Props> = ({ label, sublabel, labelType }) => {
  switch (labelType) {
    case 'text':
      return (
        <>
          {label}
          {sublabel && <div className={s['dimmed-value']}>{sublabel}</div>}
        </>
      );

    case 'checkmark':
      return <CheckIcon className={s['check']} disableDefaultColors />;

    case 'fragments':
      return (
        <div className={s['fragments-cell']}>
          {label}
          <FragmentsIcon
            className={s['fragments']}
            size={IconSize.SMALLER}
            disableDefaultColors
          />
        </div>
      );

    default:
      return null;
  }
};
BenefitField.displayName = 'BenefitField';

export default BenefitField;
